export const Logo = ({ className = "" }) => (
  <span className={`flex items-center gap-3 ${className}`}>
    <svg width="30" height="30" viewBox="0 0 32 32" aria-hidden>
      <circle cx="16" cy="16" r="14" fill="none" stroke="rgba(255,255,255,0.25)" />
      <path d="M20 4.8A12 12 0 1 0 27.2 20 9.5 9.5 0 0 1 20 4.8Z" fill="#F1F5F9" />
      <circle cx="26" cy="7" r="2" fill="#00F0FF" />
    </svg>
    <span className="leading-none">
      <span className="block font-display font-bold tracking-[0.18em] text-sm">LUNAR</span>
      <span className="block font-mono text-[9px] tracking-[0.3em] text-slate-500 mt-1">NETWORK SOLUTIONS</span>
    </span>
  </span>
);
